import { Directive, Input } from '@angular/core';

@Directive({
    standalone: true,
})
export abstract class FormFeatureDirective {
    @Input() title = '';
    @Input() textHtml = '';

    anchor = 'anchor-form';
}
